// @flow
import { get } from './common';

export const fetchUserDetails = async (mobile: string, session: string = '') => {
	try {
		const res = await get(
			'/feedback/userDetails',
			{
				mobile,
			},
			{ session }
		);
		const { status = false } = res;
		if (!status) {
			throw new Error('User details fetch error');
		}
		return res;
	} catch (error) {
		throw error;
	}
};
